import { render, staticRenderFns } from "./HaulageRate.vue?vue&type=template&id=988bbe08&scoped=true&"
import script from "./HaulageRate.vue?vue&type=script&lang=js&"
export * from "./HaulageRate.vue?vue&type=script&lang=js&"
import style0 from "./HaulageRate.vue?vue&type=style&index=0&id=988bbe08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988bbe08",
  null
  
)

export default component.exports